"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addPosition = void 0;
/**
 * @includeExample ./src/add-position.example.ts
 */
function addPosition(a, b) {
    return Object.assign(Object.assign({}, a), { x: a.x + b.x, y: a.y + b.y });
}
exports.addPosition = addPosition;
